document.addEventListener('DOMContentLoaded', function() {
  const elems = document.querySelectorAll('.product-detail-image-slider .stories');
  
  elems.forEach(function(elem) {
    new Flickity(elem, {
      cellAlign: "left",
      wrapAround: false,
      prevNextButtons:true,
      draggable: true,
      contain: true,
      lazyLoad: true,
      groupCells: true,
      pageDots: false,
      arrowShape: "M45.107632 5.82952 L53.53207 14.795201 L24.285714 46.292352 L97.808833 46.292352 L97.808833 59.383744 L24.285714 59.383744 L53.53207 90.877568 L45.107615 99.952178 L1.377755 53.778731 L45.107632 5.82952 Z"
    });
  });
});